import Base from './base';

export default class Sku extends Base {
  resource = '/skus';
}
